import { render, staticRenderFns } from "./giftcard-pins.vue?vue&type=template&id=298d269c&"
import script from "./giftcard-pins.vue?vue&type=script&lang=js&"
export * from "./giftcard-pins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports